







































import SelectDictionary from '@/components/dictionary/select-dictionary.vue'
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'application',
  components: {
    SelectDictionary
  }
})
export default class application extends Vue {
  queryFormData: any = {
    notnull_leaveDate: '1'
  }
  options: any = [
    {
      value: '书记',
      label: '书记'
    },
    {
      value: '市长',
      label: '市长'
    }
  ]
  detaileUserId: String = ''
  detailUserGroup: String = ''
  detailDialogShow: boolean = false
  pageNumber: number = 0
  pageSize: number = 5
  totalElements: number = 0
  tableData: any = []
  _self: any = this
  value: String = ''
  handleEdit(index: any, row: any) {
    console.log(index, row)
    this.detaileUserId = row.userId
    this.detailUserGroup = row.dutiesId
    this.detailDialogShow = true
  }
  close() {
    this.detaileUserId = ''
    this.detailUserGroup = ''
    this.detailDialogShow = false
  }
  objectSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
      if (rowIndex % 2 === 0) {
        return {
          rowspan: 2,
          colspan: 1
        }
      } else {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    }
  }
  mounted() {
    this.fetchTableData()
  }
  tableIndexMethod(index: number) {
    return this.pageNumber * this.pageSize + index / 2 + 1
  }
  tablePaging(pageNumber: any) {
    this.pageNumber = pageNumber - 1
    this.fetchTableData()
  }
  exportImage() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.6)'
    })
    this._self
      .$request({
        url: '/iblac/officer/images/export',
        method: 'post',
        params: this.queryFormData,
        responseType: 'blob'
      })
      .then((response: any) => {
        const blob = response.data
        loading.close()
        if ('download' in document.createElement('a')) {
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = e => {
            const a = document.createElement('a')
            var date = new Date()
            a.download = `贵宾离沪礼宾员证件信息${date.getFullYear()}-${date.getMonth()}-${date.getDay()}.zip`

            document.body.appendChild(a)
            a.href = URL.createObjectURL(blob)
            a.click()
            URL.revokeObjectURL(blob)
            document.body.removeChild(a)
          }
        } else {
          navigator.msSaveBlob(blob, '贵宾离沪礼宾员证件信息.zip')
        }
      })
      .catch((error: any) => {
        loading.close()
        console.log(error)
      })
  }
  exportData() {
    this._self
      .$request({
        url: '/iblac/departures/export',
        method: 'post',
        params: this.queryFormData,
        responseType: 'blob'
      })
      .then((response: any) => {
        const blob = response.data
        if ('download' in document.createElement('a')) {
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = e => {
            const a = document.createElement('a')
            var date = new Date()
            a.download = `离沪信息表${date.getFullYear()}-${date.getMonth()}-${date.getDay()}.xls`

            document.body.appendChild(a)
            a.href = URL.createObjectURL(blob)
            a.click()
            URL.revokeObjectURL(blob)
            document.body.removeChild(a)
          }
        } else {
          navigator.msSaveBlob(blob, '离沪信息表.xls')
        }
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  fetchTableData() {
    this._self
      .$request({
        url: '/iblac/departures/query',
        method: 'get',
        params: Object.assign(
          {
            page: this.pageNumber,
            size: this.pageSize,
            sort: 'leaveDate,asc'
          },
          this.queryFormData
        )
      })
      .then((response: any) => {
        this.tableData = response.data.content
        this.totalElements = response.data.totalElements
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
}
